import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    class: _normalizeClass(_ctx.b()),
    title: "Детали операции",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('wrapper'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('list'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Дата и время")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('item-label'))
            }, _toDisplayString(_ctx.application.created_at), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, "№ " + _toDisplayString(_ctx.$t("сделки")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('item-label'))
            }, _toDisplayString(_ctx.application.id), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item-operation'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Операция")), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('item-group'))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.b('item-icon')),
                innerHTML: _ctx.displayedChevronIcon
              }, null, 10, _hoisted_1),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('item-info'))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.b('item-label'))
                }, _toDisplayString(_ctx.displayedAmountFrom) + " " + _toDisplayString(_ctx.application.currency_from.name.toUpperCase()), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.b('item-label'))
                }, _toDisplayString(_ctx.displayedAmountTo) + " " + _toDisplayString(_ctx.application.currency_to.name.toUpperCase()), 3)
              ], 2)
            ], 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Цена исполнения")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('item-label'))
            }, _toDisplayString(_ctx.displayedExecutionPrice), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Комиссия")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('item-label'))
            }, _toDisplayString(_ctx.displayedCommissions), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Статус")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('item-label'))
            }, _toDisplayString(_ctx.$t(_ctx.displayedStatus)), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item-stage'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Этап")), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('item-steps'))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('item-step'))
              }, _toDisplayString(_ctx.application.stage), 3)
            ], 2)
          ], 2)
        ], 2),
        _createVNode(_component_UIButton, {
          label: "Закрыть",
          view: "main",
          onClick: _ctx.handleClose
        }, null, 8, ["onClick"])
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onClose"]))
}